import React, { useState } from 'react';
import axios from 'axios';

function AccountantModal({ onClose, income, tax, nationalInsurance }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [comments, setComments] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    try {
      await axios.post('/api/contactAccountant', { name, email, comments, income, tax, nationalInsurance });
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    }
  }

  return (
    <div className="modal-backdrop" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal-box">
        <div className="modal-header">
          <div>
            <div className="modal-title">Find an accountant</div>
            <div className="modal-subtitle">We'll match you with a qualified UK accountant.</div>
          </div>
          <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        {submitted ? (
          <div className="modal-success">
            <div className="modal-success-icon">✅</div>
            <div className="modal-success-title">Request sent!</div>
            <div className="modal-success-text">Thanks {name}. We'll be in touch at {email} shortly.</div>
          </div>
        ) : (
          <form className="modal-form" onSubmit={handleSubmit}>
            <div className="field-group">
              <label className="field-label" htmlFor="modal-name">Name</label>
              <input id="modal-name" className="field-input" type="text"
                placeholder="Your name" value={name}
                onChange={e => setName(e.target.value)} required />
            </div>
            <div className="field-group">
              <label className="field-label" htmlFor="modal-email">Email</label>
              <input id="modal-email" className="field-input" type="email"
                placeholder="you@example.com" value={email}
                onChange={e => setEmail(e.target.value)} required />
            </div>
            <div className="field-group">
              <label className="field-label" htmlFor="modal-comments">
                Anything to add? <span className="field-optional">Optional</span>
              </label>
              <textarea id="modal-comments" className="field-input" rows={3}
                placeholder="Any questions or context for the accountant…"
                value={comments} onChange={e => setComments(e.target.value)}
                style={{ resize: 'vertical' }} />
            </div>
            {error && <div className="error-alert">{error}</div>}
            <button type="submit" className="modal-btn">Send request</button>
          </form>
        )}
      </div>
    </div>
  );
}

export default AccountantModal;
